module.exports = __webpack_public_path__ + "assets/img/activityImg1-e5864dae.png";